import type { FrameContractDTO } from "@jobrad-gmbh/bike-leasing-calculator";
import type { CalculatorEnv } from "../configuration";
import type { BudgetCalculatorInputDTO } from "./types";

export enum BudgetCalculationActionTypes {
  BUDGET_INIT = "BUDGET_INIT",
  BUDGET_CALCULATE = "BUDGET_CALCULATE",
  BUDGET_UPDATE_INPUT = "BUDGET_UPDATE_INPUT",
  BUDGET_RESET = "BUDGET_RESET",
}

type BudgetInitAction = {
  type: BudgetCalculationActionTypes.BUDGET_INIT;
  payload: { frameContract: FrameContractDTO; calculatorEnv: CalculatorEnv };
};

type BudgetCalculateAction = {
  type: BudgetCalculationActionTypes.BUDGET_CALCULATE;
};

type BudgetUpdateInputAction = {
  type: BudgetCalculationActionTypes.BUDGET_UPDATE_INPUT;
  payload: Partial<BudgetCalculatorInputDTO>;
};

type BudgetResetAction = {
  type: BudgetCalculationActionTypes.BUDGET_RESET;
};

type BudgetCalculationAction = BudgetInitAction | BudgetCalculateAction | BudgetUpdateInputAction | BudgetResetAction;

export type {
  BudgetInitAction,
  BudgetCalculateAction,
  BudgetUpdateInputAction,
  BudgetResetAction,
  BudgetCalculationAction,
};
